import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useInfiniteQuery } from '@tanstack/react-query';
import { IImageListItem } from '@types';

async function getImageList(params: {
  pageParam: number;
  query: string;
}): Promise<AxiosResponse<FetchResult<IImageListItem[]>>> {
  const response = await instance.get(`/images?page=${params.pageParam}${params.query}`);
  return response;
}

interface UseFetchImageListCallbacks {
  onSuccess?: (data: any, variables: { pageParam: number; query: string }, context: unknown) => void;
}

const useFetchImageList = (query: string, callbacks?: UseFetchImageListCallbacks) => {
  const {
    data,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    promise,
    isLoading,
    isFetching,
    ...result
  } = useInfiniteQuery({
    queryKey: ['get', `/images${query}`],
    //queryFn: ({ pageParam }) => getImageList({ pageParam, query }),
    queryFn: async (context) => {
      const response = await getImageList({
        pageParam: context.pageParam,
        query
      });

      // pageParam이 1일 때 최상단 스크롤업을 위한 콜백 실행
      if (context.pageParam === 1 && callbacks?.onSuccess) {
        callbacks.onSuccess(response, { pageParam: context.pageParam, query }, context);
      }

      return response;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => {
      if (lastPage.data.meta && lastPage.data.meta.hasNextPage) {
        return lastPage.data.meta.page + 1;
      } else {
        return null;
      }
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(query) && query.length > 0
  });

  return {
    data,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    promise,
    isLoading,
    isFetching,
    ...result
  };
};

export default useFetchImageList;
